// extracted by mini-css-extract-plugin
export default {"description":"AccountLanguageSelect--description--aece21","localesList":"AccountLanguageSelect--localesList--913399"};